export default class NumberUtils {
  /**
   * 指定された値のいずれかが null または未定義かどうかを確認します。
   *
   * @param  {...any} numberArgs null または未定義をチェックする値
   * @returns いずれかの値が null または未定義の場合は true、それ以外の場合は false
   */
  static isNil(...numberArgs) {
    for (const number of numberArgs) {
      if (number === null || number === undefined) {
        return true
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/number.util.js